/**
 * Friend management functionality
 * Uses ListManagement for shared edit mode and removal logic
 */
(function() {
    'use strict';

    // Helper to get translation (falls back to key if i18n not available)
    function t(key) {
        return window.t ? window.t(key) : key;
    }

    // Modern friend deletion with modal
    document.addEventListener('DOMContentLoaded', function() {
        // Only initialize on friends pages
        if (!document.querySelector('[data-friends-container]')) return;

        // Initialize edit mode toggle
        window.ListManagement.initEditMode({
            deleteButtonClass: 'friend-delete-btn'
        });

        // Delegate click events for delete buttons
        document.addEventListener('click', handleDeleteClick);
    });

    function handleDeleteClick(e) {
        var deleteBtn = e.target.closest('.friend-delete-btn');
        if (!deleteBtn) return;

        e.preventDefault();
        e.stopPropagation();

        var friendId = deleteBtn.dataset.friendId;
        var username = deleteBtn.dataset.friendUsername;

        window.ListManagement.confirmAndRemove({
            title: t('common.remove_friend'),
            message: t('common.remove_friend_confirm').replace('{username}', username),
            fallbackMessage: t('common.remove_friend_fallback').replace('{username}', username),
            onConfirm: function() {
                removeFriend(deleteBtn, friendId);
            }
        });
    }

    function removeFriend(button, friendId) {
        var card = button.closest('[data-friend-card]');

        window.ListManagement.removeItem({
            button: button,
            card: card,
            url: '/app/friends/delete',
            formData: { target_id: friendId },
            errorMessage: t('common.remove_friend_error'),
            logPrefix: 'Friend removal',
            onSuccess: updateFriendsState
        });
    }

    function updateFriendsState() {
        var container = document.querySelector('[data-friends-container]');
        if (!container) return;

        var remaining = container.querySelectorAll('[data-friend-card]').length;

        if (remaining === 0) {
            // Clone empty state from hidden template
            var template = document.getElementById('friends-empty-state');
            if (template) {
                var emptyState = template.content.cloneNode(true);
                container.parentNode.replaceChild(emptyState, container);
            }
        }
    }
})();
